module.exports = __webpack_public_path__ + "img/chevron-down.cd13ff0c.svg";